import {ReportType} from "@mytour/shared";
import {Loading} from "@mytour/ui/Loading";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {useBulkUpdateMetadata, useListAllMetadata} from "../query/reportQueries";
import {MetadataForm, type SuggestionsForm} from "./MetadataForm";

type Props = {
  onClose: () => void;
};

export function MetadataEditModal({onClose}: Props) {
  const {data, isLoading, isFetching} = useListAllMetadata(ReportType.SPECTRUM);
  const bulkUpdateMetadata = useBulkUpdateMetadata();

  return (
    <Modal isOpen toggle={onClose} size="lg" className="onboarding-page">
      <ModalHeader toggle={onClose}>Modifier les suggestions</ModalHeader>
      <ModalBody>
        {isLoading || isFetching ? (
          <Loading />
        ) : (
          <MetadataForm onSubmit={handleSubmit} defaultValues={data ?? []} onClose={onClose} />
        )}
      </ModalBody>
    </Modal>
  );

  function handleSubmit({values}: SuggestionsForm) {
    const valuesToSend = (data ?? []).map(({reportId}) => {
      const found = values.find((v) => v.reportId === reportId);
      if (found) {
        return {
          reportId,
          metadata: found.metadata,
        };
      }
      return {
        reportId,
        metadata: null,
      };
    });
    bulkUpdateMetadata(valuesToSend);
    onClose();
  }
}
